import * as React from "react";
import { ProtectedRoute } from "@/components/auth";
import { ProfileContent } from "./components/ProfileContent";

export function ProfilePage() {
  return (
    <ProtectedRoute>
      <ProfileContent />
    </ProtectedRoute>
  );
}

export default ProfilePage;
